import React from 'react';
import { Common } from '@thecvlb/design-system/lib/src';

const PlansInfo: React.FC = () => {
  const wrapperClassName = 'flex gap-x-2';
  const planCardClassName = 'flex-1 flex-col';
  const planDetailsClassName = 'flex flex-col text-gray-500 text-mSm gap-0.5 mt-1';

  return (
    <div className={wrapperClassName}>
      <div className={planCardClassName}>
        <Common.ColorTag color="gray" text="Old plan" />
        <div className={planDetailsClassName}>
          <span className="font-bold">Care + Medication</span>
          <span>bundled with LifeMD</span>
        </div>
      </div>

      <div className={planCardClassName}>
        <Common.ColorTag color="primary" text="New plan" />
        <div className={planDetailsClassName}>
          <p>
            <span className="font-bold text-primary-700">Care</span> through LifeMD
          </p>
          <p>
            <span className="font-bold text-primary-700">Medication</span> directly through the
            pharmacy
          </p>
        </div>
      </div>
    </div>
  );
};

export default PlansInfo;
